var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Hero'),_c('Expierence'),_c('BestIn'),_c('OverviewBanner'),_c('AboutExp'),_c('FAQ')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }